import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCode16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCode16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.638 4.94a.5.5 0 1 0-.934-.36l-2.432 6.337a.5.5 0 0 0 .933.358zM5.21 11.506a.5.5 0 0 1-.707 0L1.356 8.361l-.353-.354.353-.353 3.147-3.147a.5.5 0 0 1 .707.707L2.417 8.007 5.21 10.8a.5.5 0 0 1 0 .707m5.585-7a.5.5 0 0 1 .707 0l3.147 3.147.353.353-.353.354-3.146 3.146a.5.5 0 0 1-.708-.707l2.793-2.793-2.793-2.793a.5.5 0 0 1 0-.707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCode16);
